function convertToFrenchDate(isoDate: string) {
    // Vérifier le format avec une regex
    const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!isoRegex.test(isoDate)) {
        throw new Error(`Format de date invalide (${isoDate}). Utilisez le format YYYY-MM-DD`);
    }

    // Séparer les composants de la date
    const [year, month, day] = isoDate.split('-');

    // Retourner la date au format français
    return `${day}/${month}/${year}`;
}

export { convertToFrenchDate };
